module.exports = "/assets/packs/images/0ffc408525a022b095789d507b3a1463.gif";